module.exports = __webpack_public_path__ + "static/far-cry_macbook-774b5ae46f7d0e5604e216b9505cb34d.png";